/**
 * Route for `report-api-custom-columns`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ReportApiCustomColumnsPage } from "../features/report-api-custom-columns/ReportApiCustomColumnsPage";

export const reportApiCustomColumnsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/report-api-custom-columns",
	component: ReportApiCustomColumnsPage,
});

export default reportApiCustomColumnsRoute;
